$(function() {
    var bigimage = $("#big");
    var thumbs = $("#thumbs");
    var syncedSecondary = true;

    bigimage
    .owlCarousel({
        items: 1,
        nav: true,
        dots: false,
        loop: true,
        navText: ['<i class="icon-angle-left-solid"></i>', '<i class="icon-angle-right-solid"></i>'],
        navClass: ['custom-prev', 'custom-next']
    })
    .on("changed.owl.carousel", syncPosition);

    thumbs
    .on("initialized.owl.carousel", function() {
        thumbs
        .find(".owl-item")
        .eq(0)
        .addClass("current");
    })
    .owlCarousel({
        items: 1,
        dots: false,
        slideBy: 1,
        responsive : {
            576 : {
                items: 3
            },
            768 : {
                items: 4
            },
            991 : {
                items: 5
            },
            1200 : {
                items: 6
            }
        }
    })

    function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }
        //to this
        thumbs
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
        .find(".owl-item.active")
        .first()
        .index();
        var end = thumbs
        .find(".owl-item.active")
        .last()
        .index();

        if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    thumbs.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
    });

    
    $('.owl-carousel--partenaires').owlCarousel({
        items: 1,
        loop: false,
        margin: 20,
        dots: false,
        nav: true,
        mouseDrag: true,
        navText: ['<i class="icon-angle-left-solid"></i>', '<i class="icon-angle-right-solid"></i>'],
        navClass: ['custom-prev', 'custom-next'],
        responsive: {
            0: {
                items: 1,
                margin: 30,
                center: true,
            },
            580: {
                items: 2,
                margin: 30,
            },
            991: {
                items: 5,
                margin: 40,
            },

            1300: {
                items: 7,
                margin: 40,
                mouseDrag: false,
                nav: true,
            },
        },
    });
});
